import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/services/application/navigation.service';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {

  constructor(private navigationService: NavigationService) { }

  ngOnInit() {
  }

  goBack() {
    this.navigationService.goBack();
  }

}
